/* eslint-disable no-undef */
import * as rq from '@tanstack/react-query';
export * from '@tanstack/react-query';

// TODO: useInfiniteQuery
// TODO: getQueryData
// TODO: setQueriesData

export function useIsFetching(...args) {
  if (Array.isArray(args[0])) {
    if (sessionStorage.getItem('react-query-debug') === '1') {
      console.warn('use react-query legacy api: useIsFetching');
      console.trace();
    }

    // return rq.useQuery({
    //   queryKey: args[0]
    // });
  }

  return rq.useIsFetching(...args);
}

export function useQuery(...args) {
  if (typeof args[1] !== 'undefined') {
    if (sessionStorage.getItem('react-query-debug') === '1') {
      console.warn('use react-query legacy api: useQuery');
      console.trace();
    }

    // return rq.useQuery({
    //   queryKey: typeof args[0] === 'string' ? [args[0]] : args[0],
    //   queryFn: args[1],
    //   ...(args[2] ?? {})
    // });
  }

  return rq.useQuery(...args);
}

export function useQueries(...args) {
  if (Array.isArray(args[0])) {
    if (sessionStorage.getItem('react-query-debug') === '1') {
      console.warn('use react-query legacy api: useQueries');
      console.trace();
    }

    return rq.useQueries({
      queries: args[0]
    });
  }

  return rq.useQueries(...args);
}

export function useMutation(...args) {
  if (typeof args[1] !== 'undefined') {
    if (sessionStorage.getItem('react-query-debug') === '1') {
      console.warn('use react-query legacy api: useMutation');
      console.trace();
    }

    // return rq.useMutation({
    //   mutationKey: typeof args[0] === 'string' ? [args[0]] : args[0],
    //   mutationFn: args[1],
    //   ...(args[2] ?? {})
    // });
  }

  return rq.useMutation(...args);
}
